import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SettingsService } from '../../settings.service';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { Subscription } from 'rxjs';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { PermissionsEnum } from 'src/app/constants/settings.enum';

@Component({
  templateUrl: './validation.page.html'
})
export class ValidationPage implements OnDestroy {

  
  // needed to setup Directives of Permission
  permissionEnum = PermissionsEnum;

  public DetachedCertificateUrl: string = PKIUrls.DetachedCertificateUrl;
  @Input('DetachedCertificate') detachedCertificate!: any;
  organisationIdSubscription: Subscription;
  selectedOrganisationId: string = "";
  organisation!: any;

  constructor(private settingsService: SettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService, private idsForSettingsService: IdsForSettingsService, private identityOrganisationApiClient: IdentityOrganisationApiClient) {
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      if (organisationId === this.selectedOrganisationId) return;
      this.selectedOrganisationId = organisationId;
      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationBasedCrumbs(BreadCrumbOptions.Security(this.selectedOrganisationId), BreadCrumbOptions.Security_Validation(this.selectedOrganisationId));

      this.getValidationSettings();
    });
  }

  ngOnDestroy(): void {
    if (this.organisationIdSubscription) {
      this.organisationIdSubscription.unsubscribe();
    }
  }

  async getValidationSettings() {
    (await this.settingsService.getDetachedCertificate(this.selectedOrganisationId)).subscribe({
      next: (dcData: any) => {
        this.detachedCertificate = dcData;
      }
    });
  }

  updateDetachedCertificate(event: any) {
    this.detachedCertificate.includeDetachedCertificate = (event.target as HTMLInputElement).checked;
    this.settingsService.updateGeneralSettings({ key: "detachedCertificate", body: this.detachedCertificate.includeDetachedCertificate }, this.selectedOrganisationId);
  }
}
